import React from "react";
import Button from "./Button";
import Card from "./Card";
import "./TacPopup.css";

function TacPopup({ onCancelClick }) {
  return (
    <div className="container">
      <Card margined>
        <div className="tacTitle">LEGAL NOTICE</div>
        <div className="tacDescription">
          This Service/Application should not be called from a script and is to be used by humans only and not by any automation tool.<br/>
          The accuracy of the response cannot be used for any legal claims towards Vodafone.<br/>
          The number entered and the number this website is called from will be kept in logfile for 90 days and can be used for troubleshooting and improvement of the service. <br/>
          This is a demo Service for trial purpose only and we do not offer any SLA.<br/> 
          To provide feedback please use the "report an issue" button but do not provide your name or contact details as we won’t respond back to you.<br/><br/>
          This notice is served by Vodafone.<br/> 
          By accessing and using this Site you acknowledge our Privacy Notice available in the Vodafone Privacy Notice portal at the following link:<br/> 
          
          <a href="https://www.vodafone.com/business/privacy-policy#privacy-policy" target="_blank" rel="noreferrer">https://www.vodafone.com/business/privacy-policy#privacy-policy</a>.<br/> 
          v. 1.97.2

        </div>
        <div className="buttons">
          <Button text="Close" btnStyle="alt1" onClick={onCancelClick} />
        </div>
      </Card>
    </div>
  );
}

export default React.memo(TacPopup);
